import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'

const TestStepSummeriesMinInfo = () =>
  <div className='grid gap-3'>
    <Header
      hasNoBottomMargin
      hasNoTopMargin
      rank={5}
    >
      Minimum time to execute
    </Header>
    <Paragraph>
      The minimum time it took for a test run to execute.
    </Paragraph>
  </div>

export default TestStepSummeriesMinInfo
